import { ThemeProvider } from "styled-components";
import { useState} from "react";
import { darkTheme, lightTheme } from './utils/Themes.js'
import Navbar from "./components/Navbar";
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import HeroSection from "./components/HeroSection";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Experience from "./components/Experience";
import Education from "./components/Education";
import styled from "styled-components";

const Body = styled.div`
  background-color: ${({ theme }) => theme.bg};
  overflow-x: hidden;
  max-width: 1500px;
  margin:auto
`

const Wrapper = styled.div`
  background:  linear-gradient(141.27deg, rgba(0, 70, 209, 0) 50%, rgba(0, 70, 209, 0.15) 100%);
  width: 100%;
  clip-path: polygon(0 0, 100% 0, 100% 100%,30% 98%, 0 100%);
`
function App() {
  // const [darkMode, setDarkMode] = useState(true);

  return (
    <ThemeProvider theme={darkTheme} >
      <Router >
        <Navbar />
        <Body>
          <HeroSection />
          <Wrapper>
            <Projects />
            <Skills />
            <Experience />
            <Education />
            <Contact />
          </Wrapper>
          <Footer />
        </Body>
      </Router>
   </ThemeProvider>
  );
}

export default App;
